import { GET_ALL_TRADE_HISTORY, GET_ALL_TRADE_HISTORY_ERROR, GET_ALL_TRADE_HISTORY_REQUEST, UPDATE_ALL_TRADE_HISTORY_DATA, REMOVE_ALL_TRADE_HISTORY } from "../../ActionTypes/ActionTypes.js";

const initialState = {
    tradeHistoryLoading: false,
    tradeHistoryData: null,
    tradeHistoryError: null,
    tradeHistoryStatus: null,
    isModified: false,
    isFirstLoad: true,

};

const tradeHistoryReducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_ALL_TRADE_HISTORY_REQUEST:
            return { ...state, tradeHistoryLoading: true, tradeHistoryStatus: null, tradeHistoryData: null };
        case GET_ALL_TRADE_HISTORY:
            return {
                tradeHistoryLoading: false, tradeHistoryData: action.payload, tradeHistoryError: null, tradeHistoryStatus: true,

                isFirstLoad: false,
            };

        case GET_ALL_TRADE_HISTORY_ERROR:
            return { tradeHistoryLoading: false, tradeHistoryData: null, tradeHistoryError: action?.payload, tradeHistoryStatus: false, isFirstLoad: false, };
        case UPDATE_ALL_TRADE_HISTORY_DATA:
            return {
                ...state,
                tradeHistoryData: {
                    ...state.tradeHistoryData,
                    result: {
                        ...state.tradeHistoryData.result,
                        ...action.payload,
                    },
                },
            };
        case REMOVE_ALL_TRADE_HISTORY:
            return { ...state, tradeHistoryData: null, tradeHistoryError: null, isModified: false, tradeHistoryStatus: null, isFirstLoad: true, tradeHistoryLoading: false }

        default:
            return state;
    }
};

export default tradeHistoryReducer;